import SvgIcon from "@mui/material/SvgIcon";

export default props => (
  <SvgIcon viewBox="0 0 15 13" {...props}>
    <path d="M1.78418 1.44531L4.53223 8.5L7.40332 0.932617L10.1514 8.5L13.0703 1.44531H14.7998L10.083 12.6699L7.36914 5.19141L4.53906 12.6768L0.0546875 1.44531H1.78418Z" />
  </SvgIcon>
);

